import { render, staticRenderFns } from "./screent_button.vue?vue&type=template&id=5fe28f3a"
import script from "./screent_button.vue?vue&type=script&lang=js"
export * from "./screent_button.vue?vue&type=script&lang=js"
import style0 from "./screent_button.vue?vue&type=style&index=0&id=5fe28f3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports